<script setup>

</script>
<template>
  <div class="content-wrapper">
    <div class="container-fluid">
      <div class="vh-80">
        <div class="mt-5 pt-3 pt-lg-5 d-flex flex-column justify-content-center align-items-center gap-4">
          <!-- Menu Item 1 -->
          <router-link
              to="request_types_and_kinds"
              class="menu-item"
          >
            <div class="menu-icon">
              <i class="fas fa-th-list"></i>
            </div>
            <div class="menu-text">
              <h3 class="h4 mb-0">Типы и виды заявок</h3>
              <p class="text-muted mb-0">Управление типами и видами заявок</p>
            </div>
          </router-link>

          <!-- Menu Item 2 -->
          <router-link
              to="users_list"
              class="menu-item"
          >
            <div class="menu-icon">
              <i class="fas fa-user-alt"></i>
            </div>
            <div class="menu-text">
              <h3 class="h4 mb-0">Список пользователей</h3>
              <p class="text-muted mb-0">Управление пользователями системы</p>
            </div>
          </router-link>

          <!-- Menu Item 3 -->
          <router-link
              to="areas_streets"
              class="menu-item"
          >
            <div class="menu-icon">
              <i class="fas fa-map-signs"></i>
            </div>
            <div class="menu-text">
              <h3 class="h4 mb-0">Участки и улицы</h3>
              <p class="text-muted mb-0">Управление участками и улицами</p>
            </div>
          </router-link>

          <!-- Menu Item 4 -->
          <router-link
              to="request_close_reasons"
              class="menu-item"
          >
            <div class="menu-icon">
              <i class="bi bi-clipboard2-x"></i>
            </div>
            <div class="menu-text">
              <h3 class="h4 mb-0">Тексты для заявок</h3>
              <p class="text-muted mb-0">Управление текстами для закрытия заявок</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 800px;
  padding: 1.5rem;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-decoration: none;
  color: inherit;
}

.menu-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.menu-icon {
  font-size: 1.5rem;
  color: #007bff;
  margin-right: 1.5rem;
}

.menu-text h3 {
  color: #343a40;
  margin-bottom: 0.5rem;
}

.menu-text p {
  font-size: 0.9rem;
  color: #6c757d;
}

.gap-4 {
  gap: 1.5rem;
}
</style>